var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Export',{attrs:{"formats":[
          { value: 'csv', label: _vm.$t('as CSV file') },
          { value: 'xls', label: _vm.$t('as XLS file') },
          { value: 'pdf', label: _vm.$t('as PDF file') },
      ],"disabled":_vm.disabled},on:{"export":function($event){return _vm.$emit('export', arguments[0])}}})
}
var staticRenderFns = []

export { render, staticRenderFns }